module.exports = __webpack_public_path__ + "img/sunday-toz.6471e61f.jpg";